'use client';

import { useCallback, useRef } from 'react';
import { type ThrottleSettings, throttle } from 'lodash-es';
export function useThrottleCallback<T extends (...args: unknown[]) => unknown>(callback: T, wait = 1000, options: ThrottleSettings = {
  trailing: false
}) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(throttle((...args: Parameters<T>) => callbackRef.current(...args), wait, options), [wait]);
}